import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { Amplify } from 'aws-amplify';
import aws_exports from './aws-exports';

const cognito = {
  region: environment.cognitoRegion,
  userPoolId: environment.cognitoUserPoolId,
  userPoolWebClientId: environment.cognitoAppClientId,
}

Amplify.configure({
  ...aws_exports,
  Auth: cognito,
})

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
